export function getIsFirefox(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    /firefox/i.test(navigator.userAgent)
  );
}
